// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".textOverflow[data-v-7f6d6e25]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.multiLine[data-v-7f6d6e25]{display:-webkit-box;white-space:unset;/*! autoprefixer: off */-webkit-box-orient:vertical}", ""]);
// Exports
module.exports = exports;
